import { render, staticRenderFns } from "./NetShopTakeOut.vue?vue&type=template&id=3d33081a&scoped=true"
import script from "./NetShopTakeOut.vue?vue&type=script&lang=js"
export * from "./NetShopTakeOut.vue?vue&type=script&lang=js"
import style0 from "./NetShopTakeOut.vue?vue&type=style&index=0&id=3d33081a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33081a",
  null
  
)

export default component.exports